import React, { useRef, useState } from "react";
import useClickOutside from "../../../hooks/useClickOutside";
import classes from "./ButtonPopup.module.css";

const ButtonPopup = ({ button, children, popupClass = "" }) => {
    const [showPopup, setShowPopup] = useState(false);
    const ref = useRef();

    useClickOutside(ref, () => setShowPopup(false));

    const handleToggle = (e) => {
        e.stopPropagation();
        setShowPopup((prev) => !prev);
    };

    return (
        <div ref={ref} className={classes.Wrap}>
            <div onClick={handleToggle} className={classes.Trigger}>
                {button}
            </div>
            {showPopup && (
                <div className={`${classes.PopupWrap} ${popupClass}`}>
                    {children}
                </div>
            )}
        </div>
    );
};

export default ButtonPopup;
